import { Component, ElementRef, Input, SimpleChanges } from '@angular/core';
import { scaleBand, range } from 'd3';

@Component({
  selector: 'app-dashboard-chart-loading-template',
  templateUrl: './dashboard-chart-loading-template.component.html',
  styleUrls: ['./dashboard-chart-loading-template.component.scss']
})
export class DashboardChartLoadingTemplateComponent {

  constructor(private elementRef: ElementRef<any>) {
  }

  @Input() height = 570;
  @Input() maxLength = 70;
  @Input() minLength = 8;
  @Input() rows = 12;
}
